/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import { markRaw } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import GoogleSignInPlugin from 'vue3-google-signin'

import 'flag-icons/css/flag-icons.min.css'
import 'v-phone-input/styles'
import {
  createVPhoneInput,
  selectPhoneCountryInput,
  VPhoneCountryFlagSvg,
  autocompletePhoneCountryInput
} from 'v-phone-input'

import vuetify from './vuetify'
import { registerAutofillSync } from './autofillSync'
import { vuetifyProTipTap, getExtensions } from './tiptap'
import router from '@/router'

const prefixVersion = `${__APP_NAME__}_version`

const versionSaved = localStorage.getItem(prefixVersion)

const isNewMinorOrMajor = () => {
  const [majorSaved, minorSaved] = versionSaved?.split('.') || [null, null]
  const [majorNew, minorNew] = __APP_VERSION__?.split('.') || [null, null]
  return majorSaved !== majorNew || minorSaved !== minorNew
}
const isNewVersion = isNewMinorOrMajor()

const checkAppVersion = () => {
  if (isNewVersion) {
    sessionStorage.clear()
    localStorage.setItem(prefixVersion, __APP_VERSION__)
  }
}

checkAppVersion()

const versionCheck = ({ store }) => {
  store.isNewVersion = isNewVersion
}

const pinia = createPinia()
pinia.use(versionCheck)
pinia.use(piniaPluginPersistedstate)
pinia.use(({ store }) => {
  store.router = markRaw(router)
})

const vPhoneInput = createVPhoneInput({
  ...selectPhoneCountryInput,
  ...autocompletePhoneCountryInput,
  countryDisplayComponent: VPhoneCountryFlagSvg
})

export function registerPlugins(app) {
  registerAutofillSync(app)

  app
    .provide('editorExtensions', getExtensions)
    .use(GoogleSignInPlugin, {
      clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID
    })
    .use(vuetify)
    .use(vuetifyProTipTap)
    .use(vPhoneInput)
    .use(router)
    .use(pinia)
}
